import actions from './actions'

const initialState = {
  active: [],
  aiList: [],
  settingsActive: [],
  loading: false,
}

export default function aiReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
